export const DEFAULT_COLORS = [
  '#00482F',
  '#006642',
  '#008254',
  '#40AD87',
  '#81D6B8',
  '#C0EADB',
  '#00A068',
  '#00B573',
  '#20C47A',
  '#00D982',
  '#4DE69C',
  '#66E0B0',
  '#99E8C7',
  '#B3F2D8',
  '#E0F7ED',
  '#003D29',
  '#005A3C',
  '#007B50',
  '#33BF85',
  '#70D9B4'
]
